/**
 * SPT Driver App
 * Main application with routing
 */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { LoginPage, ProtectedRoute } from './components/auth'
import { AppLayout } from './components/layout'
import { DeliveryPage } from './components/delivery'
import { ClockPage } from './components/clock'
import { AdminLayout, AdminDashboard, AdminDeliveries, AdminClockEntries } from './components/admin'
import { ErrorBoundary } from './components/shared'
import { ToastProvider } from './components/ui'

function App() {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* Driver Protected Routes */}
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/delivery" element={<DeliveryPage />} />
              <Route path="/clock" element={<ClockPage />} />
            </Route>
            
            {/* Admin Protected Routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="deliveries" element={<AdminDeliveries />} />
              <Route path="clock" element={<AdminClockEntries />} />
            </Route>
            
            {/* Redirect */}
            <Route path="*" element={<Navigate to="/clock" replace />} />
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </ErrorBoundary>
  )
}

export default App
